export default "__VITE_ASSET__BdQ9b35P__"